(function($) {
  Drupal.behaviors.info_popup = {
    attach: function(context, settings) {
      let $info_triggers = $('.info-popup-trigger');

      $info_triggers.once('trigger-info').each(function() {

        $(this).on('click', function() {
          $(this).toggleClass('active');

          $info_triggers.not(this).each(function() {
            $(this).removeClass('active');
          });

          $(document).on('click', function(event) {
            if (!$(event.target).hasClass('active')) {
              $info_triggers.removeClass('active');
            }
          });
        });
      });
    }
  };
})(jQuery);
